import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

interface ComicCardProps {
  comic: Comic;
  rank?: number;
}

export default function ComicCard({ comic, rank }: ComicCardProps) {
  const statusColor = comic.status === "连载中" ? "bg-primary-500" : "bg-secondary-500";
  const statusText = comic.status === "连载中" ? "text-primary-700" : "text-secondary-700";

  return (
    <article className="group flex flex-col">
      <Link
        to={`/manga/${comic.id}`}
        className="relative block overflow-hidden rounded-lg bg-background-100 focus:outline-none focus:ring-2 focus:ring-primary-400"
        aria-label={`查看漫画《${comic.title}》详情`}
      >
        <div className="relative aspect-[3/4] w-full overflow-hidden">
          <img
            src={comic.cover}
            alt={`${comic.title}漫画封面`}
            title={`${comic.title}漫画免费在线阅读`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className={`absolute left-0 top-0 rounded-br-md px-2 py-0.5 text-xs font-medium text-background-50 ${statusColor}`}>
            {comic.status}
          </span>
          {rank !== undefined && (
            <span className="absolute right-0 top-0 flex h-7 w-7 items-center justify-center rounded-bl-md bg-primary-500 text-sm font-bold text-background-50">
              {rank}
            </span>
          )}
          <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-black/60 to-transparent px-2 pb-1.5 pt-6 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <span className="flex items-center gap-1 text-xs text-background-50">
              <i className="ri-eye-line" aria-hidden="true" />
              {comic.views} 人气
            </span>
            <span className="flex items-center gap-1 text-xs text-background-50">
              <i className="ri-star-fill text-accent-400" aria-hidden="true" />
              {comic.rating}
            </span>
          </div>
        </div>
      </Link>
      <div className="mt-2.5 flex flex-col gap-1 px-0.5">
        <h3 className="truncate text-sm font-semibold text-foreground-950">
          <Link to={`/manga/${comic.id}`} className="transition-colors hover:text-primary-600">
            {comic.title}
          </Link>
        </h3>
        <p className="truncate text-xs text-foreground-700">
          <span className={`font-medium ${statusText}`}>{comic.latestChapter}</span>
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-700">
          <span className="flex items-center gap-1">
            <i className="ri-refresh-line" aria-hidden="true" />
            {comic.updatedAt}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500" aria-hidden="true" />
            {comic.rating}
          </span>
        </div>
      </div>
    </article>
  );
}